import { type BreakPolicyRule } from "@src/appV2/FacilityProfile/api/useGetFacilityProfile";

export function formatLunchBreakWarning(rule: BreakPolicyRule): string {
  const thresholdHours = rule.minShiftDurationInMinutes / 60;
  return `Shift is longer than ${thresholdHours} hours and will include a mandatory ${rule.breakDurationInMinutes}-minute lunch break`;
}
